import { render, staticRenderFns } from "./boards.vue?vue&type=template&id=1bfef746"
import script from "./boards.vue?vue&type=script&lang=js"
export * from "./boards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports